import { render, staticRenderFns } from "./resumeMessageInside.vue?vue&type=template&id=67b06431"
import script from "./resumeMessageInside.vue?vue&type=script&lang=js"
export * from "./resumeMessageInside.vue?vue&type=script&lang=js"
import style0 from "./resumeMessageInside.vue?vue&type=style&index=0&id=67b06431&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports